import { FieldFeedback } from '@piggybank/form';
import get from 'lodash/get';
import T from 'prop-types';
import React, { useCallback } from 'react';

export const DynamicFormFieldFeedback = ({ errors, fieldName }) => {
  const getErrorTestId = useCallback(() => {
    const errorKeyword = get(errors, `${fieldName}.keyword`, '');
    return errorKeyword ? `${fieldName}-error-${errorKeyword}` : null;
  }, [fieldName, errors]);

  const fieldErrorTestId = getErrorTestId();

  const fieldFeedbackProps = fieldErrorTestId
    ? {
        'data-testid': fieldErrorTestId,
      }
    : {};

  return <FieldFeedback {...fieldFeedbackProps} />;
};

DynamicFormFieldFeedback.propTypes = {
  fieldName: T.string,
  errors: T.object,
};
